import { renderText } from 'app/image/rasterize/markers/text/text';
import { fillMarkerRenderer } from './painters';
export const renderPinMarker = (marker, fonts, ctx, opts) => {
    const { x, y, width, height, innerWidth, innerHeight, descent } = marker;
    const cx = Math.round(Math.abs(width * 0.5));
    const cy = Math.round(Math.abs(height * 0.5));
    const radius = Math.max(width, height);
    const fitSquareSize = radius * Math.SQRT2;
    const scale = fitSquareSize / Math.max(innerWidth, innerHeight);
    const painter = (pCtx) => {
        pCtx.beginPath();
        pCtx.ellipse(cx, cy, radius, radius, 0, 0, 2 * Math.PI);
        pCtx.closePath();
    };
    ctx.save();
    ctx.translate(x - cx, y - cy);
    const style = {
        fillColor: marker.color,
        strokeColor: '#FFFFFF',
        strokeWidth: marker.size,
    };
    fillMarkerRenderer(ctx, style, painter, opts);
    ctx.restore();
    renderText(marker, fonts, ctx, _style => {
        ctx.fillStyle = 'white';
        ctx.save();
        ctx.scale(scale, scale);
        ctx.fillText(`${marker.number}`, -innerWidth * 0.5, innerHeight * 0.5 - descent);
        ctx.restore();
    });
};
